<script setup>
import { inject, computed } from 'vue'
import { Link, usePage } from '@inertiajs/vue3'
const __t = inject('__t')
const page = usePage()
const isRtl = computed(() => page.props.locale === 'ar')

const certTitle = __t('cert_main_title')
const certText = __t('cert_main_desc')

const certificates = [
    // { title: __t('cert_item_food_safety'), code: 'HACCP / ISO 22000' },
    // { title: __t('cert_item_ce'), code: 'European Conformity' },
    { title: __t('cert_item_iso_9001'), code: 'ISO 9001:2015' },
    { title: __t('cert_item_iso_14001'), code: 'ISO 14001:2015' },
    { title: __t('cert_item_iso_50001'), code: 'ISO 50001:2018' },
    { title: __t('cert_item_iso_45001'), code: 'ISO 45001:2018' },
    { title: __t('cert_item_iso_22000'), code: 'ISO 22000:2018' },
    { title: __t('cert_item_externa'), code: 'Externa Certification' }
]
</script>

<template>
    <section class="py-24 bg-slate-50 dark:bg-gray-950 relative overflow-hidden" :dir="isRtl ? 'rtl' : 'ltr'">
        <!-- Luxury decorative elements -->
        <div class="absolute w-80 h-80 bg-primary/5 rounded-full blur-3xl"
            :class="isRtl ? '-right-20 top-0' : '-left-20 top-0'"></div>
        <div class="absolute w-80 h-80 bg-secondary/5 rounded-full blur-3xl"
            :class="isRtl ? '-left-20 bottom-0' : '-right-20 bottom-0'"></div>

        <div class="container mx-auto px-4 relative z-10">
            <div class="text-center mb-24" :class="isRtl ? 'rtl' : 'ltr'" data-aos="fade-up">
                <h2 class="font-black text-primary mb-8 leading-tight"
                    :class="[isRtl ? 'text-4xl md:text-6xl' : 'text-3xl md:text-5xl']">
                    {{ certTitle }}
                </h2>
                <p class="max-w-4xl mx-auto leading-relaxed font-black text-gray-600"
                    :class="[isRtl ? 'text-2xl' : 'text-xl']">
                    {{ certText }}
                </p>
                <div class="w-32 h-2 bg-secondary mx-auto rounded-full mt-10"></div>
            </div>

            <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-24">
                <Link v-for="(cert, index) in certificates" :key="index" :href="route('iso-certifications')" data-aos="zoom-in" :data-aos-delay="index * 100"
                    class="group relative bg-white p-10 rounded-3xl shadow-xl shadow-primary/5 border border-gray-100 hover:border-primary transition-all duration-500 overflow-hidden text-center cursor-pointer">

                    <!-- Decorative Badge Style -->
                    <div class="absolute -top-10 w-24 h-24 bg-secondary/10 rounded-full group-hover:scale-[3] transition-transform duration-700"
                        :class="isRtl ? '-right-10' : '-left-10'">
                    </div>

                    <div class="relative z-10">
                        <div
                            class="w-20 h-20 bg-primary/5 rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:bg-primary group-hover:text-white transition-colors duration-500 text-primary">
                            <svg class="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                            </svg>
                        </div>
                        <h3 class="font-black text-primary mb-2" :class="[isRtl ? 'text-xl' : 'text-lg']">
                            {{ cert.title }}</h3>
                        <p class="text-gray-500 font-bold text-sm tracking-wider uppercase">{{ cert.code }}</p>
                    </div>
                </Link>
            </div>
            <div class="text-center mt-12" data-aos="fade-up">
                <Link href="/iso-certifications"
                    class="inline-flex items-center gap-3 bg-primary text-white px-10 py-4 rounded-full font-black hover:bg-secondary hover:text-primary transition-all transform hover:scale-105 shadow-xl shadow-primary/20 group"
                    :class="[isRtl ? 'text-xl' : 'text-lg']">
                    <span>{{ __t('home_iso_details') }}</span>
                    <svg class="w-6 h-6 transition-transform group-hover:px-1"
                        :class="isRtl ? 'group-hover:-translate-x-2 rtl:rotate-180' : 'group-hover:translate-x-2'"
                        fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M17 8l4 4m0 0l-4 4m4-4H3" />
                    </svg>
                </Link>
            </div>
        </div>
    </section>
</template>

<style scoped>
.font-black {
    font-weight: 950;
}
</style>
